import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNull } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import * as Actions from 'build-and-quote/actions/buildAndQuoteActions.js';
import OptionsResolutionsRender from 'build-and-quote/components/OptionsResolutions/OptionsResolutionsRender.jsx';

const { PurchaseMethodsActions } = PurchaseMethods;

function mapStateToProps(state) {
    const optionsResolutions = state.purchaseMethods.optionsSelectionResolutions;
    const selectedConfiguration = state.modelYear.getSelectedOptionsPackageConfiguration();
    const paymentFrequencyLabels = state.purchaseMethods.getPaymentFrequencyLabels(false, LocaleService);

    let isOnError = false;
    let selectionResolutions;
    if (!isNull(optionsResolutions) && selectedConfiguration) {
        const isLease = state.purchaseMethods.lease.selected;
        const selectedFinanceTerm = state.purchaseMethods.getSelectedFinanceTerm();
        const { taxesFactor } = state.purchaseMethods;
        isOnError = true;
        selectionResolutions = optionsResolutions.getResolutions(
            selectedConfiguration,
            isLease,
            selectedFinanceTerm,
            taxesFactor
        );
    }

    return {
        isOnError,
        selectionResolutions,
        paymentFrequencyLabels,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
        purchaseMethodsActions: bindActionCreators(PurchaseMethodsActions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OptionsResolutionsRender);
